import axios from "axios";
import { Base_Url } from "../Base Url/BaseUrl.js";

const axiosInstance = axios.create({
    baseURL: `${Base_Url}`,
});

axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('authToken'); // Use token from localStorage
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

export default axiosInstance;
